import { verifyRole } from "../helpers/verifyRole";
import { ROLES_CLAIM } from "./config.js";

/**
 * What PrivateComponent should render for the current session.
 *
 * Kept as a pure function so it can be tested without mounting React: this repo
 * has no React testing library and adding one for a four-way branch is not worth
 * a new dependency.
 *
 * `denied` is its own state on purpose. The two shorter alternatives are both
 * broken:
 *   - redirecting to /auth loops, because Login sends an authenticated visitor
 *     straight back to /admin;
 *   - calling logout() ends the session at the identity provider, which signs
 *     the person out of every other Houm app over a role check that is local to
 *     this one.
 */
export const ACCESS_LOADING = "loading";
export const ACCESS_ANONYMOUS = "anonymous";
export const ACCESS_DENIED = "denied";
export const ACCESS_ALLOWED = "allowed";

export const accessState = ({ isAuthenticated, isLoading, user } = {}) => {
  if (isLoading) return ACCESS_LOADING;
  if (!isAuthenticated) return ACCESS_ANONYMOUS;

  const roles = user ? user[ROLES_CLAIM] : undefined;
  return verifyRole(roles, "all") ? ACCESS_ALLOWED : ACCESS_DENIED;
};
